import ahoy from "ahoy.js";

ahoy.configure({
  urlPrefix: "",
  visitsUrl: "/ahoy/visits",
  eventsUrl: "/ahoy/events",
  page: null,
  platform: "Web",
  useBeacon: true,
  startOnReady: true,
  trackVisits: true,
  cookies: false,
  visitDuration: 4 * 60 * 60,
  withCredentials: false
});

document.addEventListener("turbo:load", () => {
  ahoy.trackView();
});
